<template>
  <section id="sobre">
    <img
      src="@/assets/icons/joao-foto.jpg"
      alt="Foto do criador da página, usando uma camisa polo vermelha que tem uma gola preta."
    />
    <p>
      Analista de Sistemas Júnior na empresa Welcome The Future formado na
      faculdade Estácio de Sá no curso de Análise e Desenvolvimento de Sistemas,
      com experiência em projetos utilizando Vue.js, Quasar, Sass e PostgreSQL.
    </p>
    <call-to-action-vue />
  </section>
</template>

<script>
import CallToActionVue from "@/components/General/Button/CallToAction.vue";

export default {
  name: "AboutView",
  components: {
    CallToActionVue,
  },
};
</script>

<style scoped>
section {
  display: flex;
  flex-direction: column;
  align-items: center;
}

img {
  width: 214px;
  height: 214px;
  border-radius: 50%;
}

p {
  color: var(--color-text);
  font-size: var(--fs-text-1);
  font-family: "Raleway";
  text-align: center;
  margin-top: 1.438rem;
  width: 330px;
}

@media screen and (min-width: 1000px) {
  img {
    width: 282px;
    height: 282px;
  }

  p {
    width: 577px;
  }
}
</style>
